<template>
  <div class="bbe-message-popup"
       :class="{'bbe-message-popup_minimise': minimise}">
    <transition name="bbe-fade" appear>
      <loader-fly v-if="loaderRun" :fill="true"/>
    </transition>
    <div class="bbe-message-popup-header">
      <div class="bbe-message-popup-header__title">
        <transition name="bbe-fade-options" appear>
          <span v-if="mailHeader.subject">{{mailHeader.subject}}</span>
        </transition>
        <transition name="bbe-fade-options" appear>
          <span v-if="!mailHeader.subject">{{titlePopup}}</span>
        </transition>
      </div>
      <div class="bbe-message-popup-header-controls">
        <i class="email-icon-minimise bbe-message-popup-header-controls__icon"
           :class="{'bbe-message-popup-header-controls__icon_minimise': minimise}"
           @click="changeMinimiseStatus()"/>
        <i class="email-icon-full-screen bbe-message-popup-header-controls__icon" @click="openFullSize()"/>
        <i class="email-icon-close bbe-message-popup-header-controls__icon" @click="closePopUp()"/>
      </div>
    </div>
    <div class="bbe-message-popup-details">
      <label class="bbe-label">
        <input class="bbe-message-popup-details__item bbe-input"
               :class="{'bbe-message-popup-details__item_error': error}"
               v-autofocus
               type="text"
               placeholder="Name"
               @input="generateMessage"
               v-model="mailHeader.toEmail">
        <button class="bbe-message-popup-details__copy" @click="openCopy = true" v-if="!openCopy">
          Cc
        </button>
        <button class="bbe-message-popup-details__copy" @click="openCopyHidden = true" v-if="!openCopyHidden">
          Bcc
        </button>
        <ContactsList :model="mailHeader.toEmail" modelName="toEmail" @setContact="setContact"/>
        <transition name="bbe-bounce">
          <span class="bbe-label__error" v-if="error">{{error}}</span>
        </transition>
      </label>
      <transition name="bbe-bounce">
        <label class="bbe-label" v-if="openCopy">
          <input class="bbe-message-popup-details__item bbe-input"
                 v-autofocus
                 type="text"
                 @input="generateMessage"
                 placeholder="Cc"
                 v-model="mailHeader.copy">
          <ContactsList :model="mailHeader.copy"
                        modelName="copy"
                        @setContact="setContact"/>
        </label>
      </transition>
      <transition name="bbe-bounce">
        <label class="bbe-label" v-if="openCopyHidden">
          <input class="bbe-message-popup-details__item bbe-input"
                 v-autofocus
                 type="text"
                 @input="generateMessage"
                 placeholder="Bcc"
                 v-model="mailHeader.copyHide">
          <ContactsList :model="mailHeader.copyHide"
                        modelName="copyHide"
                        @setContact="setContact"/>
        </label>
      </transition>
      <label class="bbe-label">
        <input class="bbe-message-popup-details__item bbe-input"
               type="text"
               placeholder="Subject"
               @input="generateMessage"
               v-model="mailHeader.subject">
      </label>
    </div>
    <div class="bbe-message-popup-body__wrapper" ref="bbeDropWrapperMini">
      <vue-perfect-scrollbar class="bbe-message-popup-body"
                             id="messageBody"
                             @dragenter="setCursorFromDrag"
                             @dragover="setCursorFromDrag"
                             @click="setFocusToEditor">
        <div class="bbe-message-popup-body__message"
             id="editor"
             ref="bbeEditor"/>
      </vue-perfect-scrollbar>
      <DropFiles :visibility="visibilityDrop"/>
    </div>
    <div class="bbe-message-popup-formatting">
      <transition name="bbe-bounce">
        <ToolbarTextEditor :quill="quill"
                           :formatting="activeStyle"
                           v-show="formattingOpen"
                           :shadow="true"
                           @uploadFile="getFiles"/>
      </transition>
    </div>
    <div class="bbe-message-popup-footer">
      <UploadFiles :files="uploadFiles" :narrow="true" :dropped="dropFiles"/>
      <i class="email-icon-text-colour bbe-message-popup-footer__formatting"
         :class="{'bbe-message-popup-footer__formatting_active': formattingOpen}"
         @click="formattingOpen=!formattingOpen"/>
      <button class="bbe-button" @click="generateMessage({send: true})">Send</button>
    </div>
  </div>
</template>

<script>
import ToolbarTextEditor from '@/components/Main/ToolbarTextEditor/ToolbarTextEditor'
import createMimeMessage from '@/mixin/createMimeMessage'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { get, cloneDeep } from 'lodash'
import editDraft from '@/mixin/sendDraft'
import { Jodit } from 'jodit'
import joditConfig from '@/constants/joditConfig'
import UploadFiles from '@/components/Main/UploadFiles/UploadFiles'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import base64 from '@/mixin/base64'
import validateEmail from '@/mixin/validateEmail'
import sendMessage from '@/mixin/sendMessage'
import initDropEvents from '@/mixin/initDropEvents'
import DropFiles from '@/components/Main/DropFiles/DropFiles'
import getFormatting from '@/mixin/getFormatting'
import UploadApi from '@/api/Upload/api'
import ContactsList from '@/components/Main/FormsElements/ContactsList'
import routerPush from '@/mixin/routerPush'

export default {
  name: 'NewMailPopUp',
  props: ['indexPopup'],
  components: {
    UploadFiles,
    VuePerfectScrollbar,
    ToolbarTextEditor,
    LoaderFly,
    DropFiles,
    ContactsList
  },
  mixins: [editDraft, createMimeMessage, base64, validateEmail, sendMessage, initDropEvents, getFormatting, routerPush],
  data () {
    return {
      filesIds: [],
      activeStyle: {},
      visibilityDrop: false,
      error: '',
      loaderRun: false,
      uploadFiles: [],
      dropFiles: [],
      titlePopup: 'New message',
      minimise: false,
      formattingOpen: false,
      content: '',
      quill: '',
      lastTextChange: false,
      fontSize: 16,
      mailHeader: {
        toEmail: '',
        subject: '',
        copy: '',
        copyHide: ''
      },
      openCopy: false,
      openCopyHidden: false
    }
  },
  computed: {
    newMessage: {
      get: function () {
        return this.$store.getters.newMessage
      },
      set: function (data) {
        this.$store.dispatch('setNewMessage', data)
      }
    },
    activeUser () {
      return this.$store.getters.userInfo || this.$store.getters.activeUser
    },
    draggedTemplate () {
      return this.$store.getters.draggedTemplate
    },
    activeEmail: {
      get: function () {
        return this.$store.getters.activeEmail
      },
      set: function (data) {
        this.$store.dispatch('setActiveEmail', data)
      }
    },
    activeTab () {
      return this.$store.getters.activeTab
    }
  },
  methods: {
    getFiles (filesIds) {
      this.filesIds = filesIds
    },
    checkedUploadFiles () {
      this.filesIds.forEach((id, index) => {
        const img = document.getElementById(id)
        if (!img) this.deleteFile(id, index)
      })
    },
    deleteFile (id, index) {
      UploadApi.deleteFile(id)
        .then(resp => {
          this.filesIds.splice(index, 1)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    initDrop () {
      const target = this.$refs.bbeDropWrapperMini
      this.initDropEvents({
        target: target,
        drop: this.handleDrop,
        dragEnter: () => { this.visibilityDrop = true },
        dragLeave: () => { this.visibilityDrop = false }
      })
    },
    handleDrop (e) {
      const dt = e.dataTransfer
      const files = dt.files
      this.dropFiles = [...files]
    },
    clickOnEditor (e) {
      this.getFontSize(e)
    },
    setFontSize (size) {
      this.fontSize = size
    },
    getFontSize (e) {
      const html = get(e, 'toElement.outerHTML', '16px')
      const styleFont = html.match(/font-size: \d+px/gmi) || ['16']
      const size = styleFont[0].match(/\d+/gmi) || ['16']
      this.fontSize = size[0] || 16
    },
    changeMinimiseStatus () {
      this.minimise = !this.minimise
    },
    closePopUp () {
      this.minimise = true
      setTimeout(() => {
        this.newMessage.open = false
      }, 250)
    },
    openFullSize () {
      this.newMessage.open = false
      this.activeEmail = {}
      this.$set(this.newMessage, 'openFullSize', true)
      if (this.$route.name !== 'MainPageEmail') {
        const tabName = this.activeTab.toLowerCase()
        this.routerPush({name: 'TabOpen', params: {tab: tabName}})
      }
    },
    setContact (contact, model) {
      if (!contact) return
      this.mailHeader[model] = contact
    },
    generateMessage ({send}) {
      this.error = ''
      this.lastTextChange = Date.now()
      const userId = get(this.activeUser, 'gmail.email', 'me')
      const username = this.activeUser.name || ''
      const contentHtml = this.quill.value
      const mails = {
        ...this.mailHeader,
        contentHtml: contentHtml,
        userId: userId,
        username: username,
        attachments: this.uploadFiles
      }
      const mimeMessage = this.createMimeMessage(mails)
      const raw = this.base64Encode(mimeMessage)
      const saveDraftParams = {
        raw: raw,
        message: this.newMessage,
        quill: this.quill,
        lastTextChange: this.lastTextChange,
        mailHeader: this.mailHeader,
        email: userId,
        files: this.uploadFiles
      }
      const incorrectRecipient = !mails.toEmail || !this.validateEmail(mails.toEmail)
      if (send && incorrectRecipient) {
        this.error = 'Invalid Recipient'
        return
      }
      setTimeout(() => {
        if (send) {
          this.closePopUp()
          this.sendMessage({
            mail: mimeMessage,
            loader: this.loaderRun,
            userId: get(this.activeUser, 'gmail.email', 'me'),
            callback: this.afterSendMessage
          })
        } else {
          this.saveDraft(saveDraftParams)
        }
      }, 500)
    },
    afterSendMessage (resp) {
      const message = cloneDeep(this.newMessage)
      message.status = 'sent'
      message.send = resp.result
      this.newMessage = message
    },
    setMessage () {
      this.mailHeader.toEmail = this.newMessage.toEmail || ''
      this.mailHeader.subject = this.newMessage.subject || ''
      this.uploadFiles = this.newMessage.files || []
      if (this.newMessage.contents) {
        this.quill.value = ''
        this.quill.selection.insertHTML(this.newMessage.contents)
      }
      const coordinate = this.quill.workplace.getBoundingClientRect()
      if (coordinate) {
        this.quill.selection.insertCursorAtPoint(coordinate.left, coordinate.top)
      }
    },
    setFocusToEditor () {
      this.quill.selection.focus()
    },
    setCursorFromDrag (e) {
      this.quill.selection.insertCursorAtPoint(e.pageX, e.pageY)
    },
    getStyles (e) {
      if (e) {
        this.activeStyle = this.getFormatting(e.path)
      }
    }
  },
  mounted () {
    this.initDrop()
    joditConfig.editorCssClass = 'bbe-message-popup-body__message'
    joditConfig.editorCssClass = 'bbetexteditor'
    this.quill = new Jodit('#editor', joditConfig)
    this.quill.events.on('change', (data) => {
      this.generateMessage({})
    })
    this.quill.events.on('click', (e) => {
      this.getStyles(e)
    })
    this.quill.events.on('afterInsertNode', () => {
      this.visibilityDrop = false
      this.$set(this.draggedTemplate, 'start', false)
      if (this.draggedTemplate.callback) {
        this.draggedTemplate.callback()
      }
    })
    this.setMessage()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-message-popup {
    @include global-font;
    position: absolute;
    bottom: 0;
    right: 30px;
    box-shadow: 0 0 20px rgba($color-accent, 0.25);
    background-color: $color-white;
    border-radius: 8px 8px 0 0;
    z-index: 1001;
    min-width: 589px;
    transition: .3s;
    animation: maximise .6s ease forwards;

    &_minimise {
      animation: minimise .3s ease forwards;
    }

    @keyframes minimise {
      from {
        width: 589px;
        max-height: 100%;
        overflow: hidden;
      }
      30% {
        min-width: 589px;
      }
      99% {
        max-height: 43px;
      }
      to {
        max-height: 43px;
        min-width: 285px;
        max-width: 285px;
        overflow: hidden;
      }
    }

    @keyframes maximise {
      from {
        max-height: 43px;
        min-width: 285px;
        max-width: 285px;
        overflow: hidden;
      }
      40% {
        min-width: 589px;
      }
      99% {
        max-height: 100%;
        overflow: hidden;
      }
      to {
        max-width: 589px;
        overflow: visible;
      }
    }

    &-header {
      display: flex;
      justify-content: space-between;
      padding: 9px 6px 9px 15px;
      border-radius: 8px 8px 0 0;
      background-color: $color-accent;
      transition: .3s;
      color: $color-white;

      &__title {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
      }

      &-controls {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 11px;

        &__icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 25px;
          height: 25px;
          transition: .3s;
          cursor: pointer;
          border-radius: 4px;

          &:hover {
            background-color: rgba($color-accent-hover, 0.4);
          }

          &_minimise {
            transform: scale(-1);
          }
        }
      }
    }

    &-details {
      padding: 0 15px;
      transition: .3s;

      &__item {
        border-radius: 0;
        padding: 8px 0;
        margin-top: 8px;
        border-bottom: 1px solid $color-gallery;

        &_error {
          border-bottom: 1px solid $color-pomegranate;
        }
      }

      &__copy {
        height: 100%;
        font-size: 13px;
        color: $color-silver-chalice;
        padding: 8px 10px 8px 0;
        margin-top: 8px;
        cursor: pointer;
        border-bottom: 1px solid $color-gallery;

        &:hover {
          text-decoration: underline;
        }

        &:last-child {
          margin-right: 5px;
        }
      }
    }

    &-body {
      min-height: 150px;
      height: 40vh;
      padding-right: 10px;
      transition: .3s;

      &__wrapper {
        margin: 10px 5px 10px 15px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: relative;
        height: 100%;
        min-height: 150px;
      }

      &__message {
        height: 100%;
        cursor: text;
      }
    }

    &-formatting {
      display: flex;
      justify-content: flex-end;
      min-height: 42px;
    }

    &-footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 15px;
      transition: .3s;

      &__formatting {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $color-dusty-gray;
        border-radius: 4px;
        background-color: transparent;
        min-width: 31px;
        min-height: 31px;
        margin: 0 14px;
        transition: .2s ease-in;
        cursor: pointer;

        &_active {
          color: $color-accent;
          background-color: $color-gallery;
        }

        &:hover {
          background-color: $color-gallery;
        }
      }
    }
  }

</style>

<style lang="scss">

  .bbe-message-popup-body {
    .jodit_container {
      height: 100%;

      .jodit_workplace {
        height: 100%;

        .jodit_wysiwyg {
          height: 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/NewMail/NewMailPopUp/NewMailPopUp.vue